import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShipViewTableComponent } from './ship-view-table.component';

const routes: Routes = [
   {
      path: '',
      component: ShipViewTableComponent,
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShipViewRoutingRoutingModule { }
